module.exports = __webpack_public_path__ + "img/btn-login-desktop.0f53a8b0.png";